import { Component, OnDestroy, OnInit } from '@angular/core';
import { navItems } from './../../_nav';
import { AuthenticationService } from '../../_services/authentication.service';
import { Router, NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd, RoutesRecognized, NavigationEnd, ActivatedRoute, NavigationCancel } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators/debounceTime';
import { RootService } from '../../_services/root.service';
import { LocalService } from '../../_services/local.service';
import { Title } from '@angular/platform-browser';
import { UserNav } from '../../_models/nav.class';
import { ClientService } from '../../modules/clients/clients.service';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../../account/login/login.service';
import { Console } from 'console';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {

  public navItems = [];
  public sidebarMinimized = true;
  public searchOn: boolean = false;
  public searchEvent = new Subject<string>();
  public searchSubcription: Subscription = null;
  public routerEventsSubcription: Subscription = null;
  public routesSubcription: Subscription = null;
  public navigating: boolean = false;
  public searching: boolean = false;
  public loadBarWidth: number = 0;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  public user: any;
  public com: any;
  public Dp: string = "";

  public listItems: any[] = [];

  filteredNavItems: any[] = []; // Filtered navigation items
  searchTerm: string = ''; // User input from the search box
  notificationCount = 0;
  public openNotificationDialog = false;
  private notificationInterval: any;
  public RemainingDays: number = 0;
  public openRefreshDialog = false;
  constructor(private route: ActivatedRoute,
    private titleService: Title,
    public _authenticationServie: AuthenticationService,
    private _rootService: RootService,
    private _localService: LocalService,
    private router: Router,
    private http: HttpClient,
    private clientsercice: ClientService) {
    this.changes = new MutationObserver((mutations) => {

      this.sidebarMinimized = document.body.classList.contains('sidebar-minimized');
    });
    this.changes.observe(<Element>this.element, {
      attributes: true
    });
  }
  private intervalHandle: any = undefined;
  private twohour = 7200000;
  private timeOutMills = 7200000;// two hours
  ngOnInit() {
    this.handleRouterEvents();
    this.handleSearchEvents();
    this.handleTitles();
    debugger
    this.user = this._authenticationServie.getUser();
    if (!this.user.IsRefresh) {
      this.openRefreshDialog = true;
    }
    this.com = this._authenticationServie.getCom();
    this.RemainingDays = parseInt(this.com.RemainingDays);
    this.navItems = this._authenticationServie.getNav();
    this.filteredNavItems = [...this.navItems];
    this.Dp = this.user.DP;
    if (this.Dp === "" || this.Dp == null || this.Dp == undefined) {
      this.Dp = "../../../assets/img/avatars/adminavatar.png";
    }
    else {
      this.Dp = "https://fleetdesks.s3.eu-central-1.amazonaws.com/" + this.user.DP;
    }

    this.scheduleWarning(7200000);
    this.getNotificationCount();

    this.notificationInterval = setInterval(() => {
      this.getNotificationCount();
    }, 40000); // 30,000 ms = 30 sec
  }
  scheduleWarning(mils) {
    let intervalHandle = setInterval(() => {
      // console.log(`workin everywhere ${new Date()}`)
      this.clientsercice.CheckClientBlock().subscribe((res: any) => {
        console.log('caled', res);

        if (res.IsWorning == true) {
          if (this.openPayentDueDialog == false) {
            this.openPayentDueDialog = true;
            clearInterval(intervalHandle);
          }
        }

        if (res.IsBlock == true) {
          this.router.navigate(['/locked-out']);
        }
      }, (err) => {

      });
    }, mils);
  }
  openNotifications() {
    this.openNotificationDialog = true;
    this.getNotification();
  }

  public openPayentDueDialog = false;
  ClosePayentDueDialog() {
    this.openPayentDueDialog = false;
    this.openNotificationDialog = false;
    if (this.intervalHandle == undefined) {
      this.scheduleWarning(this.timeOutMills); // set for 2 hours
    }
  }

  CloseRefreshDialog() {
    this.openRefreshDialog = false;
  }

  public handleRouterEvents() {
    this.routerEventsSubcription = this.router.events.subscribe((_) => {
      if ((_ instanceof NavigationStart)) {
        this.navigating = true;
        setTimeout(() => {
          this.loadBarWidth += 10;
        }, 100);
      }
      if ((_ instanceof NavigationEnd)) {
        this.handleTitles();
        this.navigating = false;
      }
      if ((_ instanceof NavigationCancel)) {
        this.handleTitles();
        this.navigating = false;
      }
    });
  }
  public handleSearchEvents() {
    this.searchSubcription = this.searchEvent.pipe(
      debounceTime(400)).subscribe((x) => {
        this.search(x);
      });
  }
  public async search(value: string) {
    this.listItems = [];
    if (value.length > 2) {
      this.searching = true;
      try {
        this.listItems = await this._rootService.search(value).toPromise();
        console.log(this.listItems);
      } catch (error) {
        console.log(error);
      }
    }
  }
  public searchClicked(itemName) {
    let item = this.listItems.find(x => x.Name === itemName);
    if (item) {
      let navigateTo: string[] = [];
      if (item.Type == 1) {
        navigateTo.push('/health-facility/' + item.HFMISCode);
      } else if (item.Type == 2) {
        navigateTo.push('/profile/' + item.CNIC);
      } else if (item.Type == 3) {
        navigateTo.push('/order/' + item.Id);
      }
      this.router.navigate(navigateTo);
      this.searchOn = false;
    }

  }
  public handleTitles() {
    if (this.route.children.length > 0) {
      let child = this.route.children[0];
      this.routesSubcription = child.data.subscribe(data => {
        this.setTitle(data.title);
      });
    } else {
      this.routesSubcription = this.route.data.subscribe(data => {
        this.setTitle(data.title);
      });
    }
  }
  loadUserData() {
    /*  switch (this.user.HfmisCode.length) {
         case 1:
           this.userLevelName = 'Punjab';
           break;
         case 3:
           this._mainService.getDivisionsByCode(this.user.HfmisCode).subscribe((data) => {
             this.divisions = data;
             if (data && data.length > 0) {
               this.userLevelName = data[0].Name;
             }
           }, (err) => this.handleError(err));
           this.userLevelName = 'Punjab';
           break;
         case 6:
           this._mainService.getDistrictsByCode(this.user.HfmisCode).subscribe((data) => {
             if (data && data.length > 0) {
               this.userLevelName = data[0].Name;
             }
           }, (err) => this.handleError(err));
           this.userLevelName = 'Punjab';
           break;
         case 9:
           this._mainService.getTehsilsByCode(this.user.HfmisCode).subscribe((data) => {
             if (data && data.length > 0) {
               this.userLevelName = data[0].Name;
             }
           }, (err) => this.handleError(err));
           this.userLevelName = 'Punjab';
           break;
         case 19:
           this.userLevelName = 'Punjab';
           break;
   
         default:
           break;
       } */
  }
  public setTitle(title: string) {
    this.titleService.setTitle(title + ' - ERP');
  }
  public logout() {

    debugger
    this.clientsercice.logout().subscribe((res: any) => {
      console.log('caled', res);
      this._authenticationServie.logout();
      debugger
    }, (err) => {

    });
  }

  public refreshApplication() {
    debugger
    this.clientsercice.refreshApplication().subscribe((res: any) => {
      debugger
    }, (err) => {

    });
  }

  filterNavItems(): void {
    if (this.searchTerm.trim()) {
      const lowerCaseTerm = this.searchTerm.toLowerCase();

      // Flatten the results manually using reduce
      this.filteredNavItems = this.navItems
        .map(item => this.extractMatchingItems(item, lowerCaseTerm))
        .reduce((acc, val) => acc.concat(val), []); // Flatten the array
    } else {
      // Reset to original items
      this.filteredNavItems = [...this.navItems];
    }
  }

  // Helper function to extract matching items recursively
  private extractMatchingItems(item: any, searchTerm: string): any[] {
    const matches: any[] = [];

    // Check if the current item matches
    if (item.name && item.name.toLowerCase().includes(searchTerm)) {
      matches.push({ ...item, children: null }); // Include only the item itself
    }

    // Recursively check children
    if (Array.isArray(item.children)) {
      for (const child of item.children) {
        matches.push(...this.extractMatchingItems(child, searchTerm));
      }
    }

    return matches;
  }
  navigateToDashboard() {
    this.router.navigate(['/dashboard']);
  }
  public decryptPass: any;
  public decryptUser: any;

  async loginToGarageDesks() {
    debugger
    const encryptedText = this.user.Password;  // Must be a Base64 encoded string
    const secretKey = "12345678901234567890123456789012"; // 32-byte key
    const iv = "1234567890123456"; // 16-byte IV
    try {
      this.decryptPass = await this.decryptPassword(encryptedText, secretKey, iv);
    } catch (error) {
      console.error("Decryption failed:", error);
    }

    const loginUrl = 'https://garagedesks.com/api/Account/Token';
    const loginPayload = { username: this.user.UserName, password: this.decryptPass };

    this.http.post<any>(loginUrl, loginPayload, { withCredentials: true }).subscribe(response => {
      debugger;

      if (response && response.access_token) {
        window.open('https://garagedesks.com/dashboard', '_blank');
        this.login();
      } else {
        console.error("Login failed: No token received");
      }
    });
  }

  async decryptPassword(encryptedText: string, secretKey: string, iv: string): Promise<string> {
    const keyString = secretKey;
    const keyBytes = new TextEncoder().encode(keyString);
    const ivBytes = new TextEncoder().encode(iv);

    // Convert the base64 encoded string to a Uint8Array
    const encryptedData = atob(encryptedText); // Decode base64
    const encryptedBytes = new Uint8Array(encryptedData.length);
    for (let i = 0; i < encryptedData.length; i++) {
      encryptedBytes[i] = encryptedData.charCodeAt(i); // Convert each character to a byte
    }

    // Import the key with the correct algorithm parameters
    const key = await window.crypto.subtle.importKey(
      "raw",
      keyBytes,
      { name: "AES-CBC", length: 256 }, // Specify the key length
      false,
      ["decrypt"]
    );

    // Decrypt the data
    const decrypted = await window.crypto.subtle.decrypt(
      { name: "AES-CBC", iv: ivBytes },
      key,
      encryptedBytes
    );

    // Convert the decrypted data to a string
    return new TextDecoder().decode(decrypted);
  }

  public returnUrl: string = '';
  public loadingClass: string = 'register-hr';
  public loginladda = false;
  public login() {
    this.loading(true);
    debugger
    this.clientsercice.login({ username: this.user.UserName, password: this.decryptPass }).subscribe((response: any) => {
      debugger
      if (this._authenticationServie.setUser(response)) {
        this.loading(false);
        this.router.navigate([`/${this.returnUrl}`]);
      }
    }, (err) => {
      debugger
      console.log("Failed")
      this.loading(false);
    }
    );
  }

  public loading(start: boolean) {
    if (start) {
      this.loadingClass = 'register-hr-anime';
    } else {
      this.loadingClass = 'register-hr';
    }
    this.loginladda = true;
  }
  public notificationList: any = [];
  getNotification() {
    this.clientsercice.getNotification().subscribe((res: any) => {
      console.log('caled', res);
      debugger
      this.notificationList = res.DtlList;
    }, (err) => {

    });
  }
  getNotificationCount() {
    this.clientsercice.getNotificationCount().subscribe((res: any) => {
      console.log('caled', res);
      this.notificationCount = res.TotalCount;
    }, (err) => {

    });
  }
  MarkUnread(id) {
    this.clientsercice.markUnread(id).subscribe((res: any) => {
      console.log('caled', res);
      debugger
      this.getNotificationCount();
      this.getNotification();
    }, (err) => {

    });
  }

  Refresh(): void {
    // Clear Service Worker cache (if applicable)
    if ('caches' in window) {
      caches.keys().then(function (names) {
        for (let name of names) {
          caches.delete(name); // Delete all cache entries
        }
      });
    }

    this.refreshApplication();
    // Clear LocalStorage
    localStorage.clear();  // Clears all data stored in LocalStorage

    // Clear Cookies
    this.clearCookies();  // Custom method to clear cookies

    const url = `/account/login`;  // Append timestamp as query parameter
    window.location.href = url;  // Reload with the new URL (cache-busting)
    this.logout();
  }

  // Method to clear cookies
  clearCookies(): void {
    const cookies = document.cookie.split(";");

    cookies.forEach(cookie => {
      const cookieName = cookie.split("=")[0].trim();
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
  }

  ngOnDestroy() {
    // Clear the interval when the component is destroyed to prevent memory leaks
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
    }
  }
}
